import Slider from './components/Slider';

$(() => {

    if( ! $('.hero-slider-section').length) {
        return;
    }

    const $heroSlider = $('#hero-slider');
    const $heroSliderSm = $('#hero-slider-sm');

    if( $heroSliderSm.length) {
        $heroSliderSm._slider = new Slider($heroSliderSm, {
            //items: $items,
            selector: '.keen-slider__slide',
            loop: true,
            drag: true,
            arrows: true,
            pager: true,
            slides: {
                perView: 4,
                spacing: 12
            },
            breakpoints: {
                '(max-width: 991px)': {
                    origin: 'center',
                    drag: true,
                    slides: {
                        perView: 3.4,
                        spacing: 12,
                    },
                },
                '(max-width: 767px)': {
                    origin: 'center',
                    drag: true,
                    arrows: false,
                    slides: {
                        perView: 2.4,
                        spacing: 12,
                    },
                },
            },
        });

        $heroSliderSm.find('.keen-slider__slide').on('click', e => {
            const $target = $(e.currentTarget);
            let slideIndex = +$target.attr('data-index');
            $heroSlider._slider.instance.moveToIdx(slideIndex);
        });
    }

    if ( $heroSlider.length ) {    
        $heroSlider._slider = new Slider($heroSlider, {
          fade: true,
          rubberband: false,
          loop: true,
          arrows: true,
          pager: false,
          //autoplay: 4000,
          slides: {
            perView: 1,
            spacing: 0
          },
          defaultAnimation: {
              duration: 0
          },
          detailsChanged: (s) => {
            s.slides.forEach((element, idx) => {
              if ( s.track.details.slides[idx].portion == 0 ) {
                element.style.opacity = 0;
              }
              if ( s.track.details.slides[idx].portion == 1 ) {
                element.style.opacity = 1;
                $heroSliderSm._slider.instance.moveToIdx(idx+1);
              }
            })
          },
          renderMode: "custom",
        });
        $heroSlider.find('.keen-slider__slide').first().addClass('active');
    }
});